module.exports = __webpack_public_path__ + "static/media/au.ecef4318.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/au.svg
// module id = 986
// module chunks = 0